import { html, css } from 'lit-element';
import { PatientProgressData } from '../PatientProgressData';
import { BaseElement } from './BaseElement';

import './PatientAlert';

const _data = Symbol();

class PatientAlerts extends BaseElement {
	constructor() {
		super();
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					display: block;
				}
				p {
					text-align: center;
					border: var(--theme-border, black);
					border-radius: 0.25em;
					padding: 0.25em;
					margin: 0.25em;
				}
			`
		];
	}
	get data() {
		return this[_data];
	}
	set data(v) {
		if(v !== null && !(v instanceof PatientProgressData))
			throw new TypeError('data must be an instance of PatientProgressData.');
		this[_data] = v;
		this.requestUpdate();
	}
	sortedAlerts() {
		const events = [];
		if(this.data) {
			events.push(...[...this.data.triggeredEvents].sort((a, b) => {
				if(a.createdDate < b.createdDate)
					return 1;
				if(a.createdDate > b.createdDate)
					return -1;
				return 0;
			}));
		}
		return events;
	}
	render() {
		const sortedAlerts = this.sortedAlerts();
		return html`
			<div class="${sortedAlerts.length > 0 ? '' : 'no-display'}">
				${sortedAlerts.map(v => html`<pp-patient-alert .triggeredEvent="${v}"></pp-patient-alert>`)}
			</div>
			<p class="${sortedAlerts.length === 0 ? '' : 'no-display'}">
				No alerts available.
			</p>
		`;
	}
}

customElements.define('pp-patient-alerts', PatientAlerts);